import React, { useState, useContext, useEffect } from 'react';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { NavLink, Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { LanguageContext } from '../global/languageContext';
import './home.css';
import { useDispatch, useSelector } from 'react-redux';
import { dispatchT_Language, clearLogin } from '../../Redux/ActionCreator';


const Home = () => {
	const dispatch = useDispatch();
	const { language, handleLanguageChange } = useContext(LanguageContext);
  const isAuth = useSelector(prev => prev.login);

	const navigate = useNavigate();
	const [showMobNav, setShowMobNav] = useState(false);

	const [ anchorEL, setAnchorEL ] = useState(null);
	const open = Boolean(anchorEL);
	
	const handleClick = (event) => {
		setAnchorEL(event.currentTarget)
	}

	useEffect(() => {
		// dispatch(clearLogin())
		if (isAuth.isAuthenticated === true) {
			if (isAuth?.profile_status?.profile_status === "true" && isAuth?.profile_status?.AcctType === "Client") {
				navigate("/user/dashboard");
			} else if (isAuth.profile_status.profile_status === "false" && isAuth.profile_status.AcctType === "Client") {
				navigate("/user/dashboard1");
			} 
			
			if (isAuth.profile_status?.profile_status === "true" && isAuth.profile_status?.AcctType === "Official") {
				navigate("/user/employer/profile");
			} else if (isAuth.profile_status.profile_status === "false" && isAuth.profile_status.AcctType === "Official") {
				navigate("/user/employer/form")
			}
		}
	}, [])

	const handleClose = (lg) => {
		handleLanguageChange(lg);
		dispatch(dispatchT_Language(lg));

		console.log("language selected", lg)
		setTimeout(() => {
      console.log(language['Submit'])
    }, 3000);
		
		setAnchorEL(null);
	}


	return (
		<div className="md:Landing font-main overflow-hidden md:overflow-y-scroll md:h-screen">
			<header className="px-5 sm:px-12 lg:px-32 before:content-[''] wrapper__gradient backdrop-blur-sm min-h-max lg:min-h-[100vh] flex flex-col justify-start pt-6 lg:pt-12">
				<nav className="flex justify-stretch items-center xl:w-full xl:max-w-[1280px] xl:self-center">
					<Link to="/">
						<figure className="w-[50px] sm:w-[70px] md:w-[100px]">
							<img
								src="../assets/logo.png"
								alt="moil logo"
							/>
							<figcaption>
								<p className="sr-only">Moil's Logo</p>
							</figcaption>
						</figure>
					</Link>
					<div
						onClick={(e) => {
							e.preventDefault();
							// e.stopPropagation();
							setShowMobNav(false);
						}}
						className={`flex ml-auto nav-mobile max-[1020px]:space-y-4 ${
							showMobNav ? 'nav-mobile__active' : ''
						}`}>
						<div
							className={`lg:flex lg:ml-auto max-[1020px]:space-y-2 nav__wrapper ${
								showMobNav ? 'nav__wrapper__active' : ''
							}`}>
							<ul className="max-[1020px]:space-y-2 lg:flex justify-stretch items-center ml-auto mr-3 gap-2 md:gap-11 nav_item-mobile">
								{/* <li className="text-base text-black">
									<NavLink to={'/'}>{language["Discover"]}</NavLink>
								</li> */}
								<li className="text-base text-black">
									<NavLink to={'/welcome'}>{language["Generate_cv"]}</NavLink>
								</li>
								<li className="text-base text-black">
									<NavLink to={'/'}>{language["Careers"]}</NavLink>
								</li>
							</ul>
							<ul className="max-[1020px]:space-y-2 lg:flex items-center ml-auto gap-14 nav_item-mobile">
								<li className="text-base text-black" style={{cursor: "pointer"}} onClick={handleClick}>
									<a 
										type="button"
										id="basic-button"
										aria-controls={open ? 'basic-menu' : undefined}
										aria-haspopup="true"
										aria-expanded={open ? 'true' : undefined}
										onClick={handleClick}
									>
										{language["Translate"]}
									</a>
								</li>
								<Menu
									id="basic-menu"
									anchorEl={anchorEL}
									open={open}
									onClose={handleClose}
									MenuListProps={{
										'aria-labelledby': 'basic-button',
									}}
								>
									<MenuItem onClick={() => handleClose("en")}>English</MenuItem>
									<MenuItem onClick={() => handleClose("sp")}>Español</MenuItem>
								</Menu>
								<li className="text-[#666666] text-base font-normal">
									<button
										type="button"
										className="btn-gradient py-3 px-5 rounded-xl text-white text-base font-semibold"
										onClick={() => navigate('/welcome')}>
										{language["Get_Started"]}
									</button>
								</li>
							</ul>
						</div>
					</div>
					<button
						className="relative lg:hidden right-0 z-10 ml-auto"
						type="button"
						aria-label="menu"
						onClick={() => setShowMobNav((prev) => !prev)}>
						{!showMobNav && <MenuRoundedIcon />}
						{showMobNav && <CloseRoundedIcon />}
					</button>
				</nav>
				<div className="flex flex-col md:flex-row justify-stretch items-center lg:items-center  py-10 xl:max-w-[1280px] xl:self-center xl:w-full">
					<article className="max-w-[470px] order-2 md:order-1">
						<h1 className="text-3xl md:text-4xl lg:text-6xl text-center sm:text-left font-semibold">
							<span>{language["Build"]}</span> {language["Hero_text"]}
							<span className="text-pry-900"> {language["record_time"]}</span>
						</h1>
						<p className="text-xl text-center sm:text-left text-black py-4">
						{language["hero_sub_text"]}
						</p>
						<div className="flex justify-center sm:justify-start gap-4 py-8">
							<button
								type="button"
								className="text-white bg-pry-900 rounded-xl px-6 py-3 text-base"
								onClick={() => navigate('/welcome')}>
								{language["Generate_cv"]}
							</button>
							<button
								type="button"
								className="text-black bg-white rounded-xl px-6 py-3 text-base border-sec-912 border drop-shadow-btn"
								onClick={() => navigate('/welcome')}>
								{language["Signup"]}
							</button>
						</div>
					</article>
					<figure className="order-1 sm:block max-w-[500px] ml-auto">
						<img
							src="../assets/hero_image.png"
							alt="hero image"
						/>
					</figure>
				</div>
			</header>
			<section className="px-5 sm:px-12 lg:px-32 py-8 xl:flex xl:flex-col">
				<article className="grid grid-cols-1 sm:grid-cols-2 my-14 gap-5 items-center xl:w-full xl:self-center xl:max-w-[1280px]">
					<div className="col-start-1 col-end-2">
						<figure>
							<img
								src="../assets/second_page.png"
								alt=""
							/>
						</figure>
					</div>
					<div className="grid grid-cols-2 gap-4">
						<div
							className={
								'backdrop-blur-sm rounded-[26px] bg-tet-911 border-[2px] border-tet-300 col-start-1 col-end-3 p-5'
							}>
							<h3 className="text-[#22263A] text-2xl font-medium font-main-[Poppins]">
							{language["Unlock"]}
							</h3>
							<p className="text-tet-910 text-base">
							{language["Discover"]}
							</p>
						</div>
						<figure className="col-start-1 col-end-3">
							<img
								src="../assets/admoil.webp"
								alt=""
							/>
						</figure>
					</div>
				</article>
				<h2 className="sm:text-3xl font-semibold sm:text-left text-2xl text-center text-[#0F287F]  xl:w-full xl:self-center xl:max-w-[1280px]">
				{language["Did"]}
					<br /> {language["dont"]}?
				</h2>
				<p className="w-[90%] mx-auto sm:mx-0 sm:max-w-[65%] sm:min-w-[350px] text-center sm:text-left my-4 xl:w-full xl:self-center xl:max-w-[1280px]">
				{language["Did_subText"]}
				</p>
				<div className='xl:w-full xl:max-w-[1280px] xl:self-center'>
					<button
						type="button"
						className="px-5 py-3 my-4 block sm:mx-0 mx-auto rounded-xl text-white text-base border-sec-912 border bg-pry-800 xl:w-full xl:max-w-[240px]"
						onClick={() => navigate('/welcome')}>
						{language["Get_Started"]}
					</button>
				</div>
			</section>
			<article className="mid_page flex flex-col sm:flex-row mx-5 sm:mx-12 rounded-3xl py-8 xl:w-full xl:self-center xl:max-w-[1280px] xl:mx-auto">
				<div className="hidden sm:block relative w-[411px]">
					<img
						className="absolute -top-[80px]"
						src="../assets/megaphone.png"
						alt=""
					/>
				</div>
				<div className="mx-8">
					<h2 className="text-pry-900 text-3xl sm:text-4xl text-center sm:text-left font-medium ">
					{language["Coming_soon"]}
					</h2>
					<h3 className="max-[450px]:px-2 text-3xl font-semibold text-center sm:text-left py-7">
					{language["Marching_tool"]}
					</h3>
					<p className="text-base px-4 text-center sm:px-0 sm:text-left">
						{' '}
						{language["Coming_soon_sub_text"]}
						<span className="block font-semibold">{language["Hire_Talent"]}</span>
					</p>
				</div>
			</article>
			<section className="mid_page_s flex sm:flex-row flex-col justify-center items-center gap-8 max-[640px]:px-4 px-20 py-8 my-8 ">
				<div className='xl:max-w-[1280px] flex sm:flex-row flex-col justify-center items-center gap-8'>
				<figure className="w-[264px] flex-img">
					<img
						src="../assets/cv template.webp"
						alt=""
						width={280}
					/>
				</figure>
				<div className="">
					<h2 className="text-2xl sm:text-base md:text-2xl lg:text-4xl font-medium text-center sm:text-left ">
					{language["Select_resume"]}
					</h2>
					<div className="flex gap-4 mt-7 justify-center sm:justify-start">
						<button
							type="button"
							className="px-5 py-3 rounded-xl bg-pry-900 text-white text-base font-semibold"
							onClick={() => navigate('/welcome')}>
							{language["Generate"]}
						</button>
						<button
							type="button"
							className="px-5 py-3 rounded-xl bg-white text-black text-base font-semibold border-sec-912 border drop-shadow-btn"
							onClick={() => navigate('/welcome')}>
							{language["Get_Started"]}
						</button>
					</div>
				</div>
				</div>
			</section>

			<section className="max-[640px]:px-8 max-[500px]:py-4 px-20 space-y-7 sm:space-y-3 py-20 xl:flex xl:flex-col">
				<article className="first_card review-gradient flex flex-col sm:flex-row justify-start items-center gap-7 px-7 py-4 border rounded-3xl relative xl:self-center xl:w-full xl:max-w-[1280px]">
					<figure>
						<img
							width={107}
							height={107}
							src="../assets/memoji-chat.png"
							alt="avatar"
						/>
					</figure>
					<blockquote className="max-w-[500px] text-base text-center sm:text-left">
						“{language["coat_1"]}”
						<cite className="block text-pry-900 font-light">Antana Suberu</cite>
					</blockquote>
					<figure className="absolute right-6 hidden min-[971px]:block">
						<img
							src="../assets/idea-goals.png"
							alt="idea"
						/>
					</figure>
				</article>
				<article className="second_card flex flex-col sm:flex-row justify-end items-center gap-7 px-7 py-4 border rounded-3xl relative xl:self-center xl:w-full xl:max-w-[1280px]">
					<figure className="sm:order-2">
						<img
							width={107}
							height={107}
							src="../assets/memoji-chat-2.png"
							alt="avatar"
						/>
					</figure>
					<blockquote className="max-w-[500px] text-base text-center sm:text-right">
						“{language["coat_2"]}”
						<cite className="block text-pry-900 font-light">
							Shanata Camara
						</cite>
					</blockquote>
					<figure className="absolute left-6 hidden min-[971px]:block">
						<img
							src="../assets/rocket.png"
							alt="idea"
						/>
					</figure>
				</article>

				<article className="third_card review-gradient flex flex-col sm:flex-row justify-start items-center gap-7 px-7 py-4 border rounded-3xl relative xl:self-center xl:w-full xl:max-w-[1280px]">
					<figure>
						<img
							width={107}
							height={107}
							src="../assets/memoji-chat-3.png"
							alt="avatar"
						/>
					</figure>
					<blockquote className="max-w-[500px] text-base text-center sm:text-left">
						“{language["coat_3"]}”
						<cite className="block text-pry-900 font-light">Antasia Melo</cite>
					</blockquote>
					<figure className="absolute -right-12 top-9 hidden min-[971px]:block">
						<img
							src="../assets/chat-message.png"
							alt="idea"
						/>
					</figure>
				</article>
			</section>
			<nav className="flex items-center justify-center flex-wrap mx-8 space-x-6 my-6 py-8">
				<a
					title="facebook"
					href="https://www.facebook.com/themoilapp"
					target="_blank"
					rel="noopener noreferrer">
					<img
						width={41}
						height={42}
						src="../assets/facebook-icon.png"
						alt="facebook"
					/>
				</a>
				<a
					title="instagram"
					href="https://instagram.com/themoilapp"
					target="_blank"
					rel="noopener noreferrer">
					<img
						width={41}
						height={42}
						src="../assets/instagram-icon.png"
						alt="Instagram"
					/>
				</a>
				{/* <a
					title="whatsapp"
					href="/home"
					target="_blank"
					rel="noopener noreferrer">
					<img
					width={41}
						height={42}
						src="../assets/whatsapp-icon.png"
						alt="whatsapp"
					/>
				</a> */}
				<a
					title="threads"
					href="https://www.threads.net/@themoilapp"
					target="_blank"
					rel="noopener noreferrer">
					<img
						width={41}
						height={42}
						src="../assets/threads.webp"
						alt="threads"
					/>
				</a>
				<a
					target="_blank"
					rel="noopener noreferrer"
					title="gmail"
					href="mailto:contacto@moilapp.com">
					<img
						width={41}
						height={42}
						src="../assets/gmail-icon.png"
						alt="gmail"
					/>
				</a>
				<a
					target="_blank"
					rel="noopener noreferrer"
					title="telegram"
					href="/home">
					<img
						width={41}
						height={42}
						src="../assets/telegram-icon.png"
						alt="telegram"
					/>
				</a>
				<a
					target="_blank"
					rel="noopener noreferrer"
					title="linkedin"
					href="https://www.linkedin.com/company/moilapp/">
					<img
						width={41}
						height={42}
						src="../assets/linkedin-icon.png"
						alt="LinkIn"
					/>
				</a>
				<a
					target="_blank"
					rel="noopener noreferrer"
					title="youtube"
					href="/home">
					<img
						width={41}
						height={42}
						src="../assets/youtube-icon.png"
						alt="youtube"
					/>
				</a>
			</nav>
			<footer>
				<form className="bg-pry-800 sm:max-w-[885px] sm:w-80% w-[90%] max-w-[350px] rounded-2xl mx-auto flex flex-col items-center justify-center py-9 relative top-28">
					<h2 className="text-white text-2xl px-3 sm:text-4xl max-w-[515px] font-normal text-center ">
					{language["Subscribe"]}
					</h2>
					<div className="relative w-[80%] max-w-[500px] h-[50px] mt-8">
						<input
							type="text"
							placeholder={`${language["form_enter_your_mail"]}`}
							className="text-[#999999] text-base py-3 pl-4 sm:pl-8 bg-white rounded-xl absolute w-full"
						/>
						<button
							type="submit"
							className="py-1 px-3 text-base font-normal rounded-lg absolute mr-2 bg-pry-800 text-white right-0 top-[50%] transform -translate-y-[50%]">
							{language["Subscribe_btn"]}
						</button>
					</div>
				</form>

				<section className="bg-[#F7F8FC] px-20 py-20">
					<nav className="px-0 sm:px-20 flex flex-col space-y-4 xsm:space-y-0 justify-center items-center xsm:flex-row xsm:justify-between xsm:items-start py-14 pt-32 md:max-w-[600px] md:px-0 md:mx-auto">
						<ul className="space-y-2 w-3/4 md:max-w-[160px]">
							<h3 className="text-[#222222] font-semibold text-lg ml-4 mb-2">
							{language["Company"]}
							</h3>
							<li className="text-[#666666] text-base font-normal">
								<NavLink
									to={'/'}
									className={'px-4 py-1'}>
									{language["About"]}
								</NavLink>
							</li>
							<li className="text-[#666666] text-base font-normal">
								<NavLink
									to={'/'}
									className={'px-4 py-1'}>
									{language["Careers"]}
								</NavLink>
							</li>
							<li className="text-[#666666] text-base font-normal">
								<NavLink
									to={'/'}
									className={'px-4 py-1'}>
									{language["Logistic"]}
								</NavLink>
							</li>
							<li className="text-[#666666] text-base font-normal">
								<NavLink
									to={'/'}
									className={'px-4 py-1'}>
									{language["Privacy_Policy"]}
								</NavLink>
							</li>
						</ul>
						<ul className="space-y-2 w-3/4 md:max-w-[150px]">
							<h3 className="text-[#222222] font-semibold text-lg ml-4 mb-2">
							{language["Contacts"]}
							</h3>
							<li className="text-[#666666] text-base font-normal">
								<NavLink
									to={'/'}
									className={'px-4 py-1'}>
									{language["Help_FAQ"]}
								</NavLink>
							</li>
							<li className="text-[#666666] text-base font-normal">
								<NavLink
									to={'/'}
									className={'px-4 py-1'}>
									{language["Press"]}
								</NavLink>
							</li>
							<li className="text-[#666666] text-base font-normal">
								<NavLink
									to={'/'}
									className={'px-4 py-1'}>
									{language["Affilates"]}
								</NavLink>
							</li>
						</ul>
						<ul className="space-y-2 w-3/4 md:max-w-[150px]">
							<h3 className="text-[#222222] font-semibold text-lg ml-4 mb-2">
							{language["More"]}
							</h3>
							<li className="text-[#666666] text-base font-normal">
								<NavLink
									to={'/'}
									className={'px-4 py-1'}>
									{language["Press_Centre"]}
								</NavLink>
							</li>
							<li className="text-[#666666] text-base font-normal">
								<NavLink
									to={'/'}
									className={'px-4 py-1'}>
									{language["Our_Blog"]}
								</NavLink>
							</li>
							<li className="text-[#666666] text-base font-normal">
								<NavLink
									to={'/'}
									className={'px-4 py-1'}>
									{language["Low_fare_tips"]}
								</NavLink>
							</li>
						</ul>
					</nav>
					<hr className="my-9 md:mx-auto md:max-w-[885px]" />
					<div className="flex justify-between items-center md:mx-auto md:max-w-[885px]">
						<p>{language["Copy_write"]}</p>
						<p>{language["Terms_condition"]}</p>
					</div>
				</section>
			</footer>
		</div>
	);
};

export default Home;